export const EventJournalQueries = {
    search: 'search',
    type: 'types',
    estimate: 'estimates',
    authors: 'authors',
    dateFrom: 'date_from',
    dateTo: 'date_to',
    period: 'period_picker',
    sort: 'sort',
} as const;

export const EventJournalModalQueries = {
    queryName: 'modal_mode',
    queryCreate: 'create',
    queryEdit: 'edit',
} as const;

export const currentEventId = 'current_event_id';
